export default "/images/vendor/flag-icon-css/flags/1x1/nr.svg?f088588c0fce3d304cd2136ffd6d850b";